module.exports = __webpack_public_path__ + "img/calling.2e24bc78.svg";